/**
 * Dummy data — 스케줄/휴무일/버퍼 (관리자)
 * API_DOCS: 18. 관리자 - 스케줄
 *
 * HolidayResponse:
 *   id(int), type(string?="specific"|"weekly"), specific_date(date?),
 *   weekday(string?="monday"~"sunday"), is_active(boolean), created_at(datetime)
 *
 * BufferSettingResponse:
 *   id(int), service_type(string?), direction(string?),
 *   buffer_before_minutes(int?), buffer_after_minutes(int?), description(string?)
 *
 * 캘린더: GET /api/admin/schedule (query: year, month) → 예약+블록+휴무일 통합
 */

const holidays = [
  { id: 1, type: 'specific', specific_date: '2026-03-01', weekday: null, is_active: true, created_at: '2026-01-01T00:00:00' },
  { id: 2, type: 'weekly', specific_date: null, weekday: 'sunday', is_active: true, created_at: '2026-01-01T00:00:00' },
  { id: 3, type: 'specific', specific_date: '2026-05-05', weekday: null, is_active: false, created_at: '2026-01-01T00:00:00' },
];

const blocks = [
  { id: 1, date: '2026-03-10', start_time: '14:00', end_time: '16:00', reason: '차량 정비' },
  { id: 2, date: '2026-03-25', start_time: '09:00', end_time: '12:00', reason: '정기 점검' },
];

const bufferSettings = [
  { id: 1, service_type: 'airport', direction: 'pickup', buffer_before_minutes: 30, buffer_after_minutes: 60, description: '공항 픽업 전후 버퍼' },
  { id: 2, service_type: 'airport', direction: 'sending', buffer_before_minutes: 60, buffer_after_minutes: 30, description: '공항 센딩 전후 버퍼' },
  { id: 3, service_type: 'golf', direction: null, buffer_before_minutes: 30, buffer_after_minutes: 30, description: '골프 기본 버퍼' },
];

function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

/** GET /api/admin/schedule (query: year, month) */
export const getCalendar = async (params = {}) => {
  await delay(300);
  // 예약+블록+휴무일 통합 응답 (백엔드 실제 shape에 맞춰야 하나 문서에 상세 schema 없으므로 기본 구조)
  return {
    holidays: holidays.filter((h) => h.is_active),
    blocks,
    // reservations는 예약 목록에서 가져옴 (여기서는 빈 배열)
    reservations: [],
  };
};

/** POST /api/admin/schedule/block */
export const createBlock = async (data) => {
  await delay(400);
  const block = { id: blocks.length + 1, date: data.date, start_time: data.start_time, end_time: data.end_time, reason: data.reason || null };
  blocks.push(block);
  return { message: '시간 블록이 등록되었습니다' };
};

/** DELETE /api/admin/schedule/block/:id */
export const deleteBlock = async (id) => {
  await delay(300);
  const idx = blocks.findIndex((b) => b.id === Number(id));
  if (idx === -1) throw new Error('블록을 찾을 수 없습니다');
  blocks.splice(idx, 1);
  return { message: '시간 블록이 해제되었습니다' };
};

/** GET /api/admin/holidays */
export const getHolidays = async () => {
  await delay(200);
  return holidays;
};

/** POST /api/admin/holidays */
export const createHoliday = async (data) => {
  await delay(400);
  const holiday = { id: holidays.length + 1, type: data.type, specific_date: data.specific_date || null, weekday: data.weekday || null, is_active: data.is_active !== undefined ? data.is_active : true, created_at: new Date().toISOString() };
  holidays.push(holiday);
  return holiday;
};

/** PUT /api/admin/holidays/:id */
export const updateHoliday = async (id, data) => {
  await delay(400);
  const idx = holidays.findIndex((h) => h.id === Number(id));
  if (idx === -1) throw new Error('휴무일을 찾을 수 없습니다');
  holidays[idx] = { ...holidays[idx], ...data };
  return holidays[idx];
};

/** DELETE /api/admin/holidays/:id */
export const deleteHoliday = async (id) => {
  await delay(300);
  const idx = holidays.findIndex((h) => h.id === Number(id));
  if (idx === -1) throw new Error('휴무일을 찾을 수 없습니다');
  holidays.splice(idx, 1);
  return { message: '휴무일이 삭제되었습니다' };
};

/** GET /api/admin/buffer */
export const getBuffer = async () => {
  await delay(200);
  return bufferSettings;
};

/** PUT /api/admin/buffer */
export const updateBuffer = async (data) => {
  await delay(400);
  const idx = bufferSettings.findIndex((b) => b.service_type === data.service_type && (b.direction === data.direction || (!b.direction && !data.direction)));
  if (idx !== -1) {
    bufferSettings[idx] = { ...bufferSettings[idx], ...data };
    return bufferSettings[idx];
  }
  const newSetting = { id: bufferSettings.length + 1, ...data };
  bufferSettings.push(newSetting);
  return newSetting;
};
